export default "__VITE_ASSET__80b23dce__"